module.exports = __webpack_public_path__ + "img/party.9f909e9b.jpg";